export default "__VITE_ASSET__RU20711s__"